import { useTranslation } from 'react-i18next';

export default function TagList() {
    const { t } = useTranslation('taglist');
    return {
        0: { name: t('tag-health'), color: "#B5FFCA", length: 6 },
        1: { name: t('tag-business'), color: "#FFB5B5", length: 8 },
        2: { name: t('tag-marketing'), color: "#F9FFB5", length: 9 },
        3: { name: t('tag-programming'), color: "#B5CAFF", length: 11 },
        4: { name: t('tag-life'), color: "#B5FFFF", length: 4 },
        5: { name: t('tag-balance'), color: "#B5FFFF", length: 7 },
    };
}
